import styled from 'styled-components';
import { PAGE_CONTAINER } from '../../../../../styles/Layout';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { propSwitch } from '../../../../../util/propSwitch';

export const Clickable = styled.div`
  background-color: ${propSwitch('aria-selected', ThemeColours.mono100, 'none')};

  &:active {
    background: ${ThemeColours.mono100};
  }
  cursor: pointer;
`;

export const Item = styled.div`
  ${PAGE_CONTAINER}
`;
